import React, { useState } from 'react';
import PageWrapper from '../components/PageWrapper';

const ContactPage: React.FC = () => {
    const [status, setStatus] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // This is a mock submission. In a real app, you would handle form submission here.
        setStatus('Thank you for your message! We will get back to you shortly.');
        const form = e.target as HTMLFormElement;
        form.reset();
    };

    return (
        <PageWrapper>
            <div className="py-20 sm:py-32">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="bg-[var(--panel-bg)] backdrop-blur-sm border border-[var(--border-color)] rounded-2xl p-8 md:p-12 lg:p-16 max-w-3xl mx-auto">
                        <div className="text-center mb-12">
                            <h1 className="text-4xl md:text-5xl font-extrabold text-[var(--text-primary)]">
                                Get in Touch
                            </h1>
                            <p className="mt-4 text-lg text-[var(--text-secondary)]">
                                Have a question or feedback? We'd love to hear from you.
                            </p>
                        </div>

                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label htmlFor="name" className="block text-sm font-medium text-[var(--text-secondary)] mb-2">Your Name</label>
                                <input 
                                    type="text" 
                                    id="name" 
                                    name="name"
                                    required
                                    className="w-full p-3 bg-black/20 text-[var(--text-primary)] border border-[var(--border-color)] rounded-lg focus:ring-2 focus:ring-[var(--gradient-from)] focus:outline-none transition-shadow"
                                />
                            </div>
                             <div>
                                <label htmlFor="email" className="block text-sm font-medium text-[var(--text-secondary)] mb-2">Your Email</label>
                                <input 
                                    type="email" 
                                    id="email" 
                                    name="email"
                                    required
                                    className="w-full p-3 bg-black/20 text-[var(--text-primary)] border border-[var(--border-color)] rounded-lg focus:ring-2 focus:ring-[var(--gradient-from)] focus:outline-none transition-shadow"
                                />
                            </div>
                             <div>
                                <label htmlFor="message" className="block text-sm font-medium text-[var(--text-secondary)] mb-2">Message</label>
                                <textarea 
                                    id="message" 
                                    name="message"
                                    rows={5}
                                    required
                                    className="w-full p-3 bg-black/20 text-[var(--text-primary)] border border-[var(--border-color)] rounded-lg focus:ring-2 focus:ring-[var(--gradient-from)] focus:outline-none transition-shadow resize-none"
                                ></textarea>
                            </div>
                            <div className="text-center">
                                <button type="submit" className="px-8 py-3 text-base font-semibold text-white bg-gradient-to-r from-[var(--gradient-from)] to-[var(--gradient-to)] rounded-md hover:opacity-90 transition-opacity">
                                    Send Message
                                </button>
                            </div>
                        </form>
                        {status && (
                            <p className="mt-6 text-center text-green-400">{status}</p>
                        )}
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
};

export default ContactPage;